<template>
 <div v-if="loadingProgress == 100">
  <div v-if="characteristics == null || characteristics.length == 0">
    <div class="svg-container d-flex justify-center mt-8 mb-6">
      <svg xmlns="http://www.w3.org/2000/svg" width="306" height="198" viewBox="0 0 306 198" fill="none">
<g clip-path="url(#clip0_661_205)">
<path d="M31.276 56.7764H32.8802C33.2135 59.3805 35.4219 61.3805 38.0938 61.3805H80.1927C83.0677 61.3805 85.4063 59.0472 85.4063 56.1722V14.1097C85.4063 11.2399 83.0677 8.90137 80.1927 8.90137H79.125C79.0573 5.82845 76.5156 3.29199 73.375 3.29199H31.276C28.1354 3.29199 25.5312 5.89616 25.5312 9.03678V51.0993C25.5312 54.1722 28.1354 56.7764 31.276 56.7764Z" fill="white"/>
<mask id="mask0_661_205" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="307" height="198">
<path d="M-1 0H305.922V197.948H-1V0Z" fill="white"/>
</mask>
<g mask="url(#mask0_661_205)">
<path d="M302.381 0.286133H160.646C158.709 0.286133 157.105 1.8903 157.105 3.8278V99.9059C157.105 101.843 158.709 103.448 160.646 103.448H237.896C237.698 104.448 237.495 105.385 237.36 105.984L237.829 106.25L234.287 104.047L205.688 138.765C205.553 138.635 205.287 138.635 205.089 138.703C205.021 138.765 204.954 138.833 204.886 138.901L154.704 116.135L132.448 103.916L131.448 98.8382C131.245 98.8382 131.047 98.7705 130.844 98.7705L129.443 90.7601C136.256 89.0257 141.469 81.8799 141 77.0049C140.667 73.7341 139 66.7236 136.928 60.0466V60.1143C138.464 57.3747 139.464 54.3695 139.131 51.5674C138.131 43.4893 135.922 38.7445 135.188 39.2809C134.454 39.8174 126.771 45.6247 123.36 46.4945C120.021 47.3591 103.245 50.0309 101.709 61.4476C100.172 72.8643 104.516 83.3486 103.985 85.6195C103.917 86.0205 104.318 86.3538 105.12 86.6195C105.318 88.0882 105.521 89.557 105.584 90.8278C105.652 91.8278 105.318 93.2966 104.917 94.6351C104.719 94.5674 104.584 94.5674 104.584 94.5674L102.912 99.3747C102.912 99.3747 98.438 99.3747 79.7922 105.583C78.3911 106.052 76.9172 107.119 75.5838 108.588V108.255C75.0474 108.786 21.188 167.281 -0.0620131 194.323C-0.999515 195.521 -0.129722 197.26 1.33903 197.26H35.2192C35.4224 197.26 35.5526 197.192 35.688 197.057L50.3911 180.567L47.3182 196.989C47.2505 197.26 47.4484 197.526 47.7192 197.593H47.7817C48.0526 197.593 48.2505 197.39 48.2505 197.192V197.125H155.636L155.105 158.599C170.605 163.541 190.985 169.213 204.553 172.484C212.105 174.354 219.386 170.349 222.329 163.875L255.808 117.468L252.73 115.531L253.131 115.797L258.48 108.385C258.547 108.385 258.547 108.323 258.61 108.255C260.214 106.052 261.355 104.38 262.089 103.312H302.183C304.12 103.312 305.724 101.713 305.724 99.7757V3.8278C305.922 1.8903 304.386 0.286133 302.381 0.286133Z" fill="white"/>
</g>
<path d="M302.381 0.823242H160.646C158.98 0.823242 157.574 2.22428 157.574 3.89616V99.9743C157.574 101.646 158.98 103.047 160.646 103.047H238.501C238.1 105.25 237.631 107.052 237.631 107.052L236.829 108.12C238.563 109.657 240.969 111.459 243.709 113.198C246.652 115.063 249.527 116.469 251.73 117.334L253.803 114.532L258.412 108.188C259.949 106.12 261.219 104.25 262.021 103.047H302.381C304.053 103.047 305.454 101.646 305.454 99.9743V3.82845C305.454 2.15658 304.053 0.823242 302.381 0.823242ZM273.579 78.0055C273.516 78.0055 273.449 78.0055 273.449 78.0055V86.0889C273.449 87.4899 272.313 88.693 270.839 88.693H264.829C263.756 88.693 262.824 88.0212 262.423 87.0212C261.954 85.9535 261.084 85.1514 260.016 84.6826C260.084 84.6201 260.084 84.4847 260.084 84.4847C260.553 83.016 259.214 81.3441 258.079 81.8805C257.678 82.0785 254.803 85.417 252.063 88.7555H251.995H245.985C244.579 88.7555 243.376 87.6253 243.376 86.1566V61.318C243.376 59.9118 244.511 58.7139 245.985 58.7139H270.777C272.178 58.7139 273.381 59.8493 273.381 61.318V69.3962C273.449 69.3962 273.516 69.3962 273.516 69.3962C275.917 69.3962 277.86 71.3337 277.86 73.7347C277.86 76.0732 275.985 78.0055 273.579 78.0055ZM140.6 77.141C141.001 81.6149 135.99 88.891 128.907 90.4274L130.313 98.7712C122.829 97.7035 108.928 95.3701 105.386 94.766C105.787 93.3649 106.12 91.8285 106.053 90.8285C105.985 89.5576 105.787 88.2243 105.584 86.8232C109.995 88.1566 121.891 88.5576 123.23 88.292C124.766 87.9587 128.771 81.9482 130.042 79.2087C129.173 78.4066 127.907 77.2712 126.167 75.6722C122.36 72.068 124.699 67.2607 126.834 67.9951C127.636 68.2607 128.641 68.8597 129.511 69.5264C129.912 69.1253 133.787 65.4535 136.459 60.7816C138.662 67.1253 140.334 73.8701 140.6 77.141ZM73.3757 3.69303H31.2767C28.4069 3.69303 26.0684 6.03158 26.0684 8.90137V50.9639C26.0684 53.8389 28.4069 56.1722 31.2767 56.1722H73.3757C76.2507 56.1722 78.5892 53.8389 78.5892 50.9639V8.96908C78.6569 6.09928 76.2507 3.69303 73.3757 3.69303ZM53.1986 46.3597H51.1934C49.3861 46.3597 47.9173 44.891 47.9173 43.0889H56.4017C56.4694 44.891 55.0007 46.3597 53.1986 46.3597ZM58.1413 40.7503H46.2454C45.9798 40.7503 45.7142 40.5524 45.7142 40.2139C45.7142 39.8805 45.9121 39.6826 46.2454 39.6826H58.1413C58.4069 39.6826 58.6777 39.8805 58.6777 40.2139C58.6777 40.5524 58.4069 40.7503 58.1413 40.7503ZM48.6517 23.5264L51.5267 25.9951C51.7246 26.1305 51.9954 26.1305 52.1934 25.9951L55.1361 23.5264L53.5319 37.6774C53.5319 37.6774 53.5319 37.6774 53.5319 37.7451H50.6569C50.6569 37.7451 50.6569 37.7451 50.6569 37.6774L48.6517 23.5264ZM60.0111 29.667C59.0788 31.2712 58.4746 33.0055 58.1413 34.8076C58.0059 35.4743 57.9434 36.141 57.8757 36.8128C57.8079 37.3441 57.4069 37.7451 56.8704 37.7451H54.4642L56.2038 22.391C56.2038 22.1878 56.1361 21.9899 55.9382 21.9222C55.735 21.8545 55.5371 21.8545 55.4017 21.9899L51.86 24.9951L48.3184 21.9899C48.1829 21.8545 47.9173 21.8545 47.7819 21.9222C47.584 22.0576 47.5163 22.2555 47.5163 22.4535L49.5892 37.6774H47.5163C46.9798 37.6774 46.5788 37.2764 46.5163 36.7451C46.4486 36.0785 46.3809 35.2764 46.2454 34.6097C45.9121 32.6722 45.0423 30.8701 44.11 29.1305C42.1048 25.4587 41.9694 21.8545 43.0371 19.0524C43.5059 17.516 44.4434 16.1774 45.9798 15.042C47.8496 13.7764 49.9902 13.1097 52.1257 13.1722C54.2663 13.1722 56.4694 13.7764 58.2767 15.042C59.8132 16.1149 60.7454 17.516 61.2142 19.0524C62.4173 21.9899 62.2819 25.792 60.0111 29.667Z" fill="white"/>
<path d="M85.4069 14.0413V56.1091C85.4069 58.9788 83.0684 61.3174 80.1934 61.3174H38.0944C35.2194 61.3174 32.9486 59.0466 32.8809 56.1716H73.4434C76.3184 56.1716 78.6569 53.8382 78.6569 50.9632V8.96842C78.6569 8.90072 78.6569 8.90072 78.6569 8.83301H80.1934C83.0684 8.83301 85.4069 11.1716 85.4069 14.0413ZM126.37 75.6716C122.558 72.0674 124.896 67.2601 127.037 67.9945C127.839 68.2601 128.839 68.8591 129.709 69.5257C130.376 68.8591 140.199 59.5101 139.199 51.6976C138.199 43.6195 135.99 38.8799 135.256 39.4163C134.521 39.9476 126.834 45.7601 123.428 46.6247C120.021 47.4945 103.313 50.1663 101.777 61.583C100.24 72.9997 104.584 83.4841 104.048 85.7549C103.516 88.0205 121.688 88.7549 123.36 88.3591C124.896 88.0205 128.907 82.0153 130.178 79.2757C129.308 78.4059 128.037 77.2705 126.37 75.6716ZM223.396 65.9216V47.4945C223.396 45.2913 221.594 43.4893 219.386 43.4893H200.943C198.74 43.4893 196.933 45.2913 196.933 47.4945V65.9216C196.933 68.1247 198.74 69.9268 200.943 69.9268H219.386C221.594 69.9268 223.396 68.1247 223.396 65.9216Z" fill="#D4D9DF"/>
<mask id="mask1_661_205" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="12" width="280" height="186">
<path d="M-1 12.6143H278.948V197.948H-1V12.6143Z" fill="white"/>
</mask>
<g mask="url(#mask1_661_205)">
<path d="M222.525 164.005C219.588 170.485 212.301 174.49 204.749 172.62C191.187 169.281 170.739 163.672 155.301 158.735L155.838 197.261H47.9159C47.9159 197.261 49.1867 190.115 51.3221 179.833L35.8221 197.261C35.6867 197.391 35.4888 197.458 35.3534 197.458H1.40543C-0.0633154 197.458 -0.933108 195.724 0.00439232 194.521C21.2544 167.412 75.1138 108.922 75.6502 108.386V108.724C77.0513 107.188 78.4523 106.182 79.8586 105.719C98.4992 99.5053 102.978 99.5053 102.978 99.5053L104.65 94.7657C104.65 94.7657 123.291 97.9064 131.515 99.0418L132.515 104.115L154.765 116.333L205.353 139.302L234.286 104.182L256.004 117.667L222.525 164.005ZM55.0669 23.5262L52.1242 25.9949C51.9263 26.1303 51.6554 26.1303 51.4575 25.9949L48.5825 23.5262L50.5877 37.6147C50.5877 37.6147 50.5877 37.6147 50.5877 37.6772H53.4627C53.4627 37.6772 53.4627 37.6772 53.4627 37.6147L55.0669 23.5262ZM61.3481 19.0522C60.8794 17.5157 59.9419 16.1772 58.4054 15.0418C56.5356 13.7762 54.4002 13.1095 52.2596 13.172C50.119 13.172 47.9159 13.7762 46.1138 15.0418C44.5721 16.1147 43.6398 17.5157 43.1711 19.0522C42.1034 21.8543 42.1711 25.4585 44.2388 29.1303C45.1763 30.8699 46.0461 32.672 46.3794 34.6095C46.5148 35.3439 46.645 36.0782 46.645 36.7449C46.7127 37.2762 47.1138 37.6772 47.6502 37.6772H49.7179L47.5825 22.3907C47.5825 22.1876 47.6502 21.9897 47.8481 21.8543C48.0513 21.7866 48.2492 21.7866 48.3846 21.922L51.9263 24.9272L55.4679 21.922C55.5981 21.7866 55.869 21.7866 55.9992 21.8543C56.2023 21.922 56.27 22.1199 56.27 22.323L54.5304 37.6772H56.9367C57.4731 37.6772 57.8742 37.2762 57.9419 36.7449C58.0044 36.1407 58.0721 35.4064 58.2075 34.7397C58.5409 32.9376 59.1398 31.2032 60.0773 29.5991C62.2804 25.7918 62.4159 21.9897 61.3481 19.0522ZM273.577 69.396C273.515 69.396 273.447 69.396 273.447 69.396V61.3178C273.447 59.9116 272.312 58.7137 270.838 58.7137H246.046C244.645 58.7137 243.442 59.8491 243.442 61.3178V86.0887C243.442 87.4897 244.577 88.6928 246.046 88.6928H252.062H252.129C254.869 85.3543 257.744 82.0157 258.145 81.8126C259.28 81.3439 260.614 82.948 260.15 84.4168C260.15 84.4845 260.083 84.5522 260.083 84.6199C261.15 85.021 262.02 85.8855 262.489 86.9532C262.89 87.9585 263.822 88.6251 264.895 88.6251H270.905C272.312 88.6251 273.515 87.4897 273.515 86.021V77.9428C273.577 77.9428 273.645 77.9428 273.645 77.9428C276.051 77.9428 277.989 76.0053 277.989 73.5991C277.859 71.3335 275.984 69.396 273.577 69.396Z" fill="#656464"/>
</g>
<path d="M53.1992 46.3594H51.194C49.3867 46.3594 47.918 44.8906 47.918 43.0885H56.4023C56.4701 44.8906 55.0013 46.3594 53.1992 46.3594ZM263.09 33.474C264.762 34.4063 266.835 34.4063 268.501 33.3385L287.882 21.3854C287.746 19.7865 286.413 18.5156 284.809 18.5156H246.319C244.579 18.5156 243.178 19.9167 243.178 21.6563V22.2552L263.09 33.474ZM269.038 34.276C268.038 34.875 266.897 35.2083 265.694 35.2083C264.626 35.2083 263.559 34.9427 262.621 34.4063L243.178 23.4583V43.4896C243.178 45.224 244.579 46.625 246.319 46.625H284.809C286.543 46.625 287.949 45.224 287.949 43.4896V22.5885L269.038 34.276Z" fill="#D4D9DF"/>
<mask id="mask2_661_205" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="24" y="0" width="282" height="198">
<path d="M24.2812 0H305.922V197.948H24.2812V0Z" fill="white"/>
</mask>
<g mask="url(#mask2_661_205)">
<path d="M302.38 0.286133H160.646C158.708 0.286133 157.104 1.8903 157.104 3.8278V99.9059C157.104 101.843 158.708 103.448 160.646 103.448H237.896C237.698 104.448 237.495 105.385 237.359 105.984L238.297 106.521C238.698 104.651 239.969 98.8382 239.969 96.3018C239.969 94.9007 240.505 93.9632 241.104 93.9007C241.641 93.833 242.172 94.432 242.505 95.4997C242.844 96.5674 243.307 97.7028 243.776 98.7705C243.844 98.9059 243.979 99.0413 244.177 99.0413C244.38 99.0413 244.51 98.9736 244.646 98.8382L247.052 95.7028C251.063 90.7601 257.677 82.7497 258.344 82.2809C258.677 82.1455 259.01 82.4163 259.146 82.4788C259.547 82.8174 259.88 83.5518 259.615 84.2861C259.547 84.5518 258.948 85.6872 255.87 90.3591L250.458 97.7705C250.328 97.9736 250.328 98.307 250.594 98.4372C250.661 98.5049 250.792 98.5049 250.859 98.5049C250.995 98.5049 251.193 98.4372 251.26 98.307L256.542 91.0934C257.073 91.0934 258.01 91.359 258.411 91.8955C258.609 92.1611 258.677 92.432 258.609 92.8278C258.547 93.0309 258.411 93.2966 258.208 93.6976L254 99.9736C253.87 100.177 253.932 100.51 254.135 100.64C254.203 100.708 254.333 100.708 254.401 100.708C254.536 100.708 254.734 100.64 254.802 100.51L258.948 94.3018C259.547 94.0309 260.281 94.1663 260.818 94.6976C261.417 95.2341 261.62 96.0361 261.286 96.8382L258.146 101.51C258.01 101.713 258.078 102.047 258.276 102.177C258.344 102.244 258.479 102.244 258.547 102.244C258.677 102.244 258.88 102.177 258.948 102.047L261.885 97.7028C262.151 97.8382 262.49 98.1038 262.688 98.5726C263.021 99.3747 262.755 100.442 262.089 101.713C261.688 102.448 260.281 104.448 258.01 107.588C257.943 107.588 257.943 107.651 257.875 107.718L252.396 115.265L253.266 115.797L258.609 108.385C258.677 108.385 258.677 108.323 258.745 108.255C260.349 106.052 261.484 104.38 262.219 103.312H302.312C304.25 103.312 305.854 101.713 305.854 99.7757V3.8278C305.922 1.8903 304.385 0.286133 302.38 0.286133ZM304.922 99.9736C304.922 101.375 303.786 102.51 302.38 102.51H262.953C263.021 102.448 263.021 102.38 263.089 102.312C263.958 100.708 264.156 99.3747 263.755 98.307C263.422 97.5049 262.891 97.1038 262.49 96.8382C262.755 95.7705 262.422 94.7653 261.62 94.0309C261.083 93.4997 260.349 93.2966 259.682 93.2966V93.2288C259.88 92.5622 259.75 91.8955 259.349 91.3591C258.813 90.7601 258.01 90.4268 257.276 90.2913C260.083 85.9528 260.552 85.0205 260.682 84.682C261.016 83.682 260.682 82.5466 259.88 81.8122C259.281 81.2809 258.609 81.1455 257.943 81.4111C257.073 81.8122 249.458 91.1611 246.25 95.1663L244.38 97.6403C244.047 96.8382 243.776 96.0361 243.443 95.2341C242.641 92.8278 241.302 92.8955 240.901 92.9632C239.766 93.1663 238.901 94.6351 238.964 96.3695C238.964 97.7705 238.563 100.307 238.161 102.51H160.646C159.245 102.51 158.109 101.375 158.109 99.9736V3.8278C158.109 2.42676 159.245 1.29134 160.646 1.29134H302.38C303.786 1.29134 304.922 2.42676 304.922 3.8278V99.9736ZM141.135 77.1403C141.604 81.9476 136.391 89.0934 129.573 90.8955L130.979 98.9059C130.646 98.8382 130.313 98.8382 129.911 98.7705L128.505 90.5622C128.438 90.2913 128.641 90.0257 128.906 89.958C134.318 88.7549 140.667 82.5466 140.198 77.208C139.932 74.2028 138.396 67.6559 136.391 61.3799C136.656 60.9788 136.859 60.583 137.057 60.182C139.13 66.8591 140.802 73.8018 141.135 77.1403ZM106.656 90.8278C106.724 91.8955 106.385 93.432 105.984 94.9007C105.583 94.833 105.25 94.7653 104.984 94.6976C105.385 93.2966 105.719 91.8278 105.651 90.8955C105.583 89.6247 105.385 88.1559 105.182 86.6872C105.521 86.8226 105.854 86.8903 106.255 87.0205C106.453 88.359 106.589 89.6247 106.656 90.8278ZM73.375 3.22363H31.276C28.1354 3.22363 25.5312 5.8278 25.5312 8.96842V51.0309C25.5312 54.1716 28.1354 56.7757 31.276 56.7757H73.375C76.5156 56.7757 79.125 54.1716 79.125 51.0309V8.96842C79.125 5.76009 76.5833 3.22363 73.375 3.22363ZM78.1198 51.0309C78.1198 53.6351 75.9844 55.7757 73.375 55.7757H31.276C28.6719 55.7757 26.5312 53.6351 26.5312 51.0309V8.96842C26.5312 6.36426 28.6719 4.22884 31.276 4.22884H73.375C75.9844 4.22884 78.1198 6.36426 78.1198 8.96842V51.0309ZM58.6771 40.2809C58.6771 40.5518 58.474 40.8174 58.1406 40.8174H46.2448C45.9792 40.8174 45.7135 40.6143 45.7135 40.2809C45.7135 39.9476 45.9115 39.7497 46.2448 39.7497H58.1406C58.4063 39.7497 58.6771 40.0153 58.6771 40.2809ZM58.8073 141.64L48.3854 197.26C48.3177 197.526 48.1146 197.661 47.9167 197.661H47.849C47.5833 197.593 47.3802 197.323 47.4479 197.057L57.875 141.437C57.9427 141.172 58.2083 140.974 58.474 141.036C58.6771 141.104 58.875 141.369 58.8073 141.64ZM212.568 149.854C212.703 150.119 212.635 150.385 212.438 150.521C212.37 150.588 212.234 150.588 212.172 150.588C212.036 150.588 211.833 150.521 211.771 150.317L204.953 139.437C204.818 139.166 204.885 138.901 205.089 138.765C205.354 138.635 205.62 138.703 205.755 138.901L212.568 149.854ZM223.729 18.9163C223.865 19.0518 223.865 19.2497 223.865 19.3851L222.396 23.9216C222.328 24.057 222.193 24.1924 222.057 24.2601C221.995 24.2601 221.995 24.2601 221.927 24.2601C221.792 24.2601 221.656 24.1924 221.594 24.1247L220.391 22.9216L215.312 27.9945V43.5518H214.307V28.9997L209.828 33.4736C208.229 35.0726 206.089 35.9424 203.818 35.9424H201.88C200.073 35.9424 198.339 36.6091 197 37.7445L183.901 48.8278C183.839 48.8955 183.703 48.9632 183.568 48.9632C183.438 48.9632 183.302 48.8955 183.167 48.7601C182.969 48.5622 183.036 48.2288 183.234 48.0257L196.333 36.9424C197.87 35.609 199.807 34.9424 201.88 34.9424H203.818C205.823 34.9424 207.693 34.1403 209.161 32.7393L214.307 27.5986V23.057C214.307 21.2549 212.839 19.7861 211.031 19.7861H175.349C173.547 19.7861 172.073 21.2549 172.073 23.057V58.5778C172.073 60.3799 173.547 61.8486 175.349 61.8486H196.932V62.8486H175.349C173.01 62.8486 171.073 60.9163 171.073 58.5778V23.057C171.073 20.7184 173.01 18.7809 175.349 18.7809H210.901C213.24 18.7809 215.177 20.7184 215.177 23.057V26.5934L219.521 22.2549L218.115 20.8538C217.984 20.7184 217.917 20.5205 217.984 20.3851C218.052 20.1872 218.182 20.0518 218.318 20.0518L223.13 18.8486C223.396 18.7184 223.594 18.7809 223.729 18.9163ZM289.484 59.9111C287.214 59.9111 285.344 61.7809 285.344 64.0518V87.0882C285.344 89.3591 287.214 91.2288 289.484 91.2288C291.755 91.2288 293.625 89.3591 293.625 87.0882V64.0518C293.625 61.7132 291.823 59.9111 289.484 59.9111ZM292.625 87.0882C292.625 88.8226 291.224 90.2288 289.484 90.2288C287.745 90.2288 286.344 88.8226 286.344 87.0882V66.7236C287.078 67.5934 288.214 68.1924 289.484 68.1924C290.755 68.1924 291.891 67.6559 292.625 66.7236V87.0882ZM289.484 67.1924C287.745 67.1924 286.344 65.7861 286.344 64.0518C286.344 62.3174 287.745 60.9163 289.484 60.9163C291.224 60.9163 292.625 62.3174 292.625 64.0518C292.625 65.7861 291.224 67.1924 289.484 67.1924ZM214.844 78.1403H176.151C173.88 78.1403 172.01 80.0101 172.01 82.2809C172.01 84.5518 173.88 86.4216 176.151 86.4216H214.844C217.115 86.4216 218.984 84.5518 218.984 82.2809C218.984 80.0101 217.115 78.1403 214.844 78.1403ZM173.01 82.2809C173.01 80.5466 174.411 79.1403 176.151 79.1403C177.891 79.1403 179.292 80.5466 179.292 82.2809C179.292 84.0153 177.891 85.4163 176.151 85.4163C174.411 85.4163 173.01 84.0153 173.01 82.2809ZM214.844 85.4163H178.823C179.693 84.682 180.297 83.5518 180.297 82.2809C180.297 81.0101 179.76 79.8747 178.823 79.1403H214.844C216.578 79.1403 217.984 80.5466 217.984 82.2809C217.984 84.0153 216.578 85.4163 214.844 85.4163Z" fill="black"/>
</g>
</g>
<defs>
<clipPath id="clip0_661_205">
<rect width="306" height="198" fill="white"/>
</clipPath>
</defs>
</svg>
          <p class="infotext">Die Prozesslandkarte konnte nicht erstellt werden, da noch keine Prozesssteckbriefe existieren. Fügen Sie Prozesssteckbriefe hinzu, um die Prozesslandkarte nutzen zu können.</p>
      <v-btn text color="primary" @click="goToCharacteristic()">zu den Prozesssteckbriefen</v-btn>
        </div>
  </div>
  <div :class="showSidePanel ? 'container sideBarContainer' : 'container'" v-else >
    <FilterComponent :characteristicPresent="true" @applyFilter="applyFilter" @resetFilter="resetFilter" @applyTextFilter="applyTextFilter"/>
    <v-row>
      <v-col>
        <v-select
          prepend-icon="mdi-arrow-up-bold"
          :items="axisDescriptors"
          item-text="name"
          label="Y-Achse"
          v-model="yAxis"
          return-object
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          prepend-icon="mdi-arrow-right-bold"
          :items="axisDescriptors"
          item-text="name"
          label="X-Achse"
          v-model="xAxis"
          return-object
        ></v-select>
      </v-col>
    </v-row>
   <div v-if="loadingProgress == 100">
    <v-row v-for="yIndx in axisValues.y.length+1" :key="yIndx">
      <v-col v-for="xIndx in axisValues.x.length+1" :key="xIndx">
        <span v-if="yIndx == axisValues.y.length+1 && xIndx == 1">
          <v-icon color="primary">mdi-arrow-up-bold</v-icon>{{yName}}
          <v-divider style="margin:0px"/>
          {{xName}}<v-icon color="primary">mdi-arrow-right-bold</v-icon>
        </span>
        <span v-if="yIndx < axisValues.y.length+1 && xIndx == 1">{{axisValues.y[axisValues.y.length - yIndx]}}</span>
        <span v-if="xIndx > 1 && yIndx == axisValues.y.length+1">{{axisValues.x[xIndx-2]}}</span>
        <div ref="main" v-if="xIndx > 1 && yIndx < axisValues.y.length+1" class="main">
          <div v-for="characteristic in gridContent[xIndx-2][axisValues.y.length-yIndx]" :key="characteristic.id" >
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <div @click="openProcessDetails(characteristic)" v-bind="attrs" v-on="on">
                <div ref="box" class="circleFrame" :style="'background-color:'+ (characteristic.department == null ? 'gray':characteristic.department[0].color)"/>
              </div>
            </template>
            <process-characteristic-short-details-card :characteristic="characteristic"></process-characteristic-short-details-card>
          </v-tooltip>
          </div>
        </div>
      </v-col>
    </v-row>
   </div>
   <v-row>
    Legende:
     <ColorLegend :items="filteredDepartments">
       <template #default="{ item: department }">
         {{ department.friendlyName }}
       </template>
     </ColorLegend>
   </v-row>
  </div>
   <div id="filter" v-if="showSidePanel" style="margin-top: 1px">
      <v-card style="height: 100%">
        <v-card
          style="position: absolute; top: 0; right: 0; left: 0; height:100%; overflow: auto;"
        >         
          <v-card-title>Prozessdaten</v-card-title>
          <v-card-text>
            <ProcessCharacteristicDetailCard :characteristic="selectedProcess" />
          </v-card-text>
        </v-card>
      </v-card>
    </div>
   <div :class="showSidePanel ? 'sidePanelExpand' : 'sidePanelCollapsed'" @click="showSidePanel = !showSidePanel">
    <div style="background-color:#EBEBEB" v-if="!showSidePanel">
      <v-icon color="primary">mdi-chevron-left-box</v-icon>
      <!-- <div>F <br/> I <br/> L <br/> T <br/> E <br/> R</div> -->
    </div>
    <div style="background-color:#EBEBEB" v-if="showSidePanel">
      <v-icon color="primary">mdi-chevron-right-box</v-icon>
      <!-- <div>F <br/> I <br/> L <br/> T <br/> E <br/> R</div> -->
    </div>
  </div>
 </div>
 
</template>

<script>
import ProcessCharacteristicDetailCard from './ProcessCharacteristicDetailCard.vue';
import connectedRessourceService
  from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
import processMapService from '@/components/processMapService.js';
import Vue from 'vue';
import FilterComponent from '@/components/FilterComponent.vue';
import ProcessCharacteristicShortDetailsCard from './ProcessCharacteristicShortDetailsCard.vue';
import ColorLegend from "@/pages/ProcessMap/ColorLegend.vue";

export default {
  name: "ProcessMap",
  components:{
    ColorLegend,
    ProcessCharacteristicDetailCard,
    FilterComponent,
    ProcessCharacteristicShortDetailsCard
  },
  data() {
    return {
      loadingProgress: 0,
      showSidePanel: false,
      characteristics: [],
      selectedProcess: {},
      show: {},
      processType: [
        {name: "Kernprozess", value: "CORE"},
        {name: "Führungsprozess", value:"LEADERSHIP"},
        {name: "Unterstützungsprozess", value:"SUPPORT"}
      ],
      highMidLowOptions: [
        {name: "Hoch", value: "HIGH"},
        {name: "Mittel", value: "MEDIUM"},
        {name: "Gering", value: "LOW"}
      ],
      axisDescriptors: [],
      axisValues: {
        x: null,
        y: null
      },
      grid: null,
      search: '',
      xAxis: '',
      yAxis: '',
      gridContent: [],
      customFields: [],
      departments: [],
      initialPositionsSet: false,
      filteredDepartments: []
    };
  },
  computed:{
    userId(){
      return this.$store.state.user.username;
    },
    xName(){
      return this.axisDescriptors.find(elem => elem.fieldId == this.xAxis.fieldId).name;
    },
    yName(){
      return this.axisDescriptors.find(elem => elem.fieldId == this.yAxis.fieldId).name;
    }
  },
  watch:{
    xAxis(){
      this.initAxis();
    },
    yAxis(){
      this.initAxis();
    },
    showSidePanel(){
      this.resetCirclePositions(true);
    }
  },
  async mounted() {
    this.retrieveProcessCharacteristics();    
  },
  methods: {
    goToCharacteristic (){
      this.$router.push({name:"processCharacteristic"});
    },
    createAxis(){ 
      this.axisDescriptors = [];
      this.characteristics.forEach(character => {
        character.customFields.forEach(field => {
          if(field != null && field.customField.diagram && !this.axisDescriptors.find(e => e.name == field.customField.name)){
            this.axisDescriptors.push({
              name: field.customField.name,
              id: field.customField.id,
              fieldId: field.customField.fieldId,
              custom: true
            })
          }
        })
      })
      this.xAxis = this.axisDescriptors[0];
      this.yAxis = this.axisDescriptors[1];
    },
    orderOptions(values){
      const specificOrder = ["Keine Angabe", "Gering", "Mittel", "Hoch"];
      return values.sort((a, b) => {
          const indexA = specificOrder.indexOf(a);
          const indexB = specificOrder.indexOf(b);
          // If both values are in specificOrder, compare their indices
          if (indexA !== -1 && indexB !== -1) {
              return indexA - indexB;
          }
          // If only one value is in specificOrder, prioritize it
          if (indexA !== -1) {
              return -1;
          }
          if (indexB !== -1) {
              return 1;
          }
          // If neither value is in specificOrder, sort alphabetically
          return a.localeCompare(b);
      });
    },
    initAxis(){
      this.loadingProgress = 0;
      if(this.xAxis.custom){
        let field = this.customFields.find(elem => elem.fieldId == this.xAxis.fieldId);
        if(field.fieldType == "NUMBER"){
          let ranges = this.calcRanges(field);
          field.options = ranges;
        }else{
          field.options = this.orderOptions(field.options)
        }
        this.axisValues.x = field.options;
      }else{
        this.axisValues.x = [...new Set(this.characteristics.map(e => e[this.xAxis]))];
      }
      if(this.yAxis.custom){
        let field = this.customFields.find(elem => elem.fieldId == this.yAxis.fieldId);
        if(field.fieldType == "NUMBER"){
          let ranges = this.calcRanges(field);
          field.options = ranges;
        }else{
          field.options = this.orderOptions(field.options)
        }
        this.axisValues.y = field.options;
      }else{
        this.axisValues.y = [...new Set(this.characteristics.map(e => e[this.yAxis]))];
      }
      this.generateAxisValues();
    },
    calcRanges(field){
      let ranges = [];
      let rangeCount = (field.maxValue - field.minValue) / 5;
      ranges.push(field.minValue+"-"+(field.minValue+rangeCount));
      let lastRangeNum = field.minValue+rangeCount;
      for(let i = 0; i < 3; ++i){
        ranges.push(lastRangeNum+1+"-"+(lastRangeNum+rangeCount));
        lastRangeNum = lastRangeNum+rangeCount;
      }
      ranges.push(lastRangeNum+1+"-"+field.maxValue);
      return ranges;
    },
    retrieveProcessCharacteristics() {
      this.processes = [];      
      processMapService.retrieveProcessCharacteristics(false, this.characteristics).then(res => {
        this.characteristics = res.data;
        if(this.characteristics == null || this.characteristics.length == 0) {
          this.loadingProgress = 100;
          return;
        }
        this.characteristics.forEach(elem => {
          if(elem.department) elem.department = [elem.department];
          Vue.set(this.show, elem.id, false);
        })
        processMapService.getCustomFields().then(response => {
          this.customFields = response.data;
          this.createAxis();
          this.initAxis();
          connectedRessourceService.retrieveConnectedRessources().then((res) => {
            this.departments = res.data.filter(elem => elem.type == "DEPARTMENT");
            this.filteredDepartments = this.departments;
          });
        })
        
      })
    },
    generateAxisValues(filteredValues){
      this.loadingProgress = 0;
      if(filteredValues == null) filteredValues = this.characteristics;
      this.gridContent = Array(this.axisValues.x.length).fill().map(() => Array(this.axisValues.y.length).fill([]));

      for (let y = 0; y < this.axisValues.y.length; ++y) {
        for (let x = 0; x < this.axisValues.x.length; ++x) {
            // Calculate mirrored indices for x and y
            const mirroredX = x;
            const mirroredY = this.axisValues.y.length - 1 - y;
            
            if (mirroredY < this.axisValues.y.length && mirroredY >= 0 && mirroredX < this.axisValues.x.length && mirroredX >= 0) {
                // Your existing logic for populating gridContent
                if (this.xAxis.custom && !this.yAxis.custom) {
                    this.gridContent[mirroredX][mirroredY] = filteredValues.filter(elem => elem[this.yAxis.fieldId] == this.axisValues.y[mirroredY] && field.fieldValue == this.axisValues.x[mirroredX]);
                } else if (!this.xAxis.custom && this.yAxis.custom) {
                    this.gridContent[mirroredX][mirroredY] = filteredValues.filter(elem => elem.customFields.find(field => field.customField.fieldId == this.yAxis.fieldId).fieldValue == this.axisValues.y[mirroredY] && elem[this.xAxis.fieldId] == this.axisValues.x[mirroredX]);
                } else if (this.xAxis.custom && this.yAxis.custom) {
                    let fieldX = this.customFields.find(field => field.fieldId == this.xAxis.fieldId);
                    let fieldY = this.customFields.find(field => field.fieldId == this.yAxis.fieldId);
                    if (fieldX.fieldType == "NUMBER" && fieldY.fieldType != "NUMBER") {
                        let minRange = this.axisValues.x[mirroredX].split("-")[0];
                        let maxRange = this.axisValues.x[mirroredX].split("-")[1];
                        this.gridContent[mirroredX][mirroredY] = filteredValues.filter(elem => elem.customFields.find(field => field.customField.fieldId == this.yAxis.fieldId).fieldValue == this.axisValues.y[mirroredY] && this.inRange(elem.customFields.find(field => field.customField.fieldId == this.xAxis.fieldId).fieldValue, minRange, maxRange));
                    } else if (fieldX.fieldType != "NUMBER" && fieldY.fieldType == "NUMBER") {
                        let minRange = this.axisValues.y[mirroredY].split("-")[0];
                        let maxRange = this.axisValues.y[mirroredY].split("-")[1];
                        this.gridContent[mirroredX][mirroredY] = filteredValues.filter(elem => elem.customFields.find(field => field.customField.fieldId == this.xAxis.fieldId).fieldValue == this.axisValues.x[mirroredX] && this.inRange(elem.customFields.find(field => field.customField.fieldId == this.yAxis.fieldId).fieldValue, minRange, maxRange));
                    } else if (fieldX.fieldType == "NUMBER" && fieldY.fieldType == "NUMBER") {
                        let minRangeX = this.axisValues.x[mirroredX].split("-")[0];
                        let maxRangeX = this.axisValues.x[mirroredX].split("-")[1];
                        let minRangeY = this.axisValues.y[mirroredY].split("-")[0];
                        let maxRangeY = this.axisValues.y[mirroredY].split("-")[1];
                        this.gridContent[mirroredX][mirroredY] = filteredValues.filter(elem => this.inRange(elem.customFields.find(field => field.customField.fieldId == this.xAxis.fieldId).fieldValue, minRangeX, maxRangeX) && this.inRange(elem.customFields.find(field => field.customField.fieldId == this.yAxis.fieldId).fieldValue, minRangeY, maxRangeY));
                    } else {
                        this.gridContent[mirroredX][mirroredY] = filteredValues.filter(elem => elem.customFields.find(field => field.customField.fieldId == this.yAxis.fieldId).fieldValue == this.axisValues.y[mirroredY] && elem.customFields.find(field => field.customField.fieldId == this.xAxis.fieldId).fieldValue == this.axisValues.x[mirroredX]);
                    }
                } else {
                    this.gridContent[mirroredX][mirroredY] = this.characteristics.filter(elem => elem[this.yAxis.fieldId] == this.axisValues.y[mirroredY] && elem[this.xAxis.fieldId] == this.axisValues.x[mirroredX]);
                }
            } else {
                this.gridContent[mirroredX][mirroredY] = [];
            }
        }
      }
      this.resetCirclePositions(true);
      this.loadingProgress = 100;
    },
    resetCirclePositions(forceRerender = false){
      this.loadingProgress = 0;
      if(!this.initialPositionsSet || forceRerender){
        this.initialPositionsSet = true;
        this.$nextTick(() => {
        if(this.$refs != null && this.$refs.main != null){
          this.$refs.main.forEach(frame => {
            const {
              clientWidth: mainWidth,
              clientHeight: mainHeight,
            } = frame;
            this.$refs.box.forEach((box) => {
              if(box.style.left == "" || forceRerender) box.style.left = Math.random() * (mainWidth - box.clientWidth - 20) + "px";
              
              if(box.style.top == "" || forceRerender) box.style.top = Math.random() * (mainHeight - box.clientHeight - 20) + "px";
            });
          })
        }
      })
      }
      this.loadingProgress = 100;
    },
    inRange(num, minVal, maxVal){
      return (parseInt(num) < parseInt(maxVal) && parseInt(num) > parseInt(minVal));
    },
    filterData(filterType, filterValue){
      let filteredCharacteristics = [];
      let copyCharacteristics = JSON.parse(JSON.stringify(this.characteristics));
      //copyCharacteristics.filter(item => item.)
      if(filterValue != null) var filterIds = filterValue.map(e => e.id);
      switch(filterType){
        case "SYSTEM":
          copyCharacteristics.forEach(char => {
            let characteristicDep = char.systems.map(e => e.id);
            if(characteristicDep.some(e => filterIds.includes(e))) filteredCharacteristics.push(char)
          })
          break;
        case "DEPARTMENT":
          copyCharacteristics.forEach(char => {
            //let characteristicDep = char.connectedDepartments.map(e => e.id);
            //if(characteristicDep.some(e => filterIds.includes(e))) filteredCharacteristics.push(char)
            if(char.department && filterIds.includes(char.department[0].id)) filteredCharacteristics.push(char)
          })
          break;
        case "ROLE":
          copyCharacteristics.forEach(char => {
            let characteristicDep = char.involvedRoles.map(e => e.id);
            if(characteristicDep.some(e => filterIds.includes(e))) filteredCharacteristics.push(char)
          })
          break;
        case "RESET":
          filteredCharacteristics = copyCharacteristics;
        default:
          filteredCharacteristics = copyCharacteristics;
      }
      this.generateAxisValues(filteredCharacteristics);
    },
    openProcessDetails(item){
      this.selectedProcess = item;
      this.showSidePanel = true;
    },
    applyFilter(filterItems){
      this.loadingProgress = 0;
      let filteredCharacteristics = this.characteristics;
            if(filterItems.textFilter != null && filterItems.textFilter != ""){
              filteredCharacteristics = filteredCharacteristics.filter(e => e.name.toUpperCase().includes(filterItems.textFilter.toUpperCase()));
            }
            if(filterItems.processTypeFilter.length > 0){
              filteredCharacteristics = filteredCharacteristics.filter(elem => {
                let fieldVal = elem.customFields.find(field => field.customField.fieldId == "prozessart");
                if(fieldVal == null) return null;
                if(filterItems.processTypeFilter.includes(fieldVal.fieldValue)) return elem;
              })
            }
            if(filterItems.contextFilter.length > 0){
              filteredCharacteristics = filteredCharacteristics.filter(elem => {
                return (elem.involvedRoles && elem.involvedRoles.some(role => filterItems.contextFilter.includes(role.id))) ||
                      (elem.connectedDepartments && elem.connectedDepartments.some(department => filterItems.contextFilter.includes(department.id))) ||
                      (elem.systems && elem.systems.some(system => filterItems.contextFilter.includes(system.id))) ||
                      (elem.department && elem.department.some(department => filterItems.contextFilter.includes(department.id)))
              })

              const connectedDepartmentIds = filterItems.contextFilter.filter(id => this.departments.flatMap(obj => obj.id).includes(id))

              if(connectedDepartmentIds.length > 0){
                this.filteredDepartments = this.departments.filter(dep => connectedDepartmentIds.includes(dep.id))
              }else{
                this.filteredDepartments = this.departments
              }
            }else{
              this.filteredDepartments = this.departments
            }
          this.loadingProgress = 100;
          this.generateAxisValues(filteredCharacteristics);
    },
    resetFilter(){
      this.filteredDepartments = this.departments;
      this.generateAxisValues(this.characteristics);
    },
    applyTextFilter(filterItems){
      let filteredCharacteristics = [];
      if(filterItems.textFilter != ""){
        filteredCharacteristics = this.characteristics.filter(char => {
          return char.name.toUpperCase().includes(filterItems.textFilter.toUpperCase())
        })
      }else{
        filteredCharacteristics = this.characteristics;
      }
      this.generateAxisValues(filteredCharacteristics);
    },
  }
};
</script>

<style scoped>
.svg-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 200px;
}

.container{
  height:100%;
}
.sideBarContainer{
  margin-left: 25px;
  max-width: calc(100% - 400px) !important;
}
.main{
  min-height: 100px;
  max-height: 20px;
  min-width: 50px;
  margin: 0px;
  border: 1px dotted #31307A;
  background: #f2f2f2;
  position: relative;
}
.circleFrame{
  width: 20px;
  height: 20px;
  border-radius: 50px;
  position: absolute;
  cursor: pointer;
}

.circleFrame:hover{
  width: 20px;
  height: 20px;
  border-radius: 50px;
  color:#000000;
}

.circleFrame:hover::after{
  content: "Prozessdetails";
  position: absolute;
  background-color: rgba(0,0,0,0.4);
  color: #ffffff;
  top: 150%;
  left: 50%;
  padding: 5px;
  border-radius: 5px;
  z-index: 1;
}

.characteristicItem{
  height: 10%;
  width:10%;
  margin: 5px;
}
#filter{
  position: absolute;
  width: 350px;
  right: 0;
  z-index: 99;
  top: 0px;
  bottom: 0px;
}
.v-tooltip__content{
  padding: 0 !important;
}
</style>